import PropTypes from 'prop-types';

export const CONDITIONS__COLLAPSE_ALL = 'CONDITIONS__COLLAPSE_ALL';
export const CONDITIONS__CREATE = 'CONDITIONS__CREATE';
export const CONDITIONS__DELETE = 'CONDITIONS__DELETE';
export const CONDITIONS__FETCH = 'CONDITIONS__FETCH';
export const CONDITIONS__PATCH = 'CONDITIONS__PATCH';
export const CONDITIONS__REPLACE = 'CONDITIONS__REPLACE';
export const CONDITIONS__UPDATE = 'CONDITIONS__UPDATE';

export const CONDITIONS__SHAPE_ITEM = PropTypes.shape({
  afterPosition: PropTypes.number,
  expand: PropTypes.bool,
  expandEditForm: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  shuffled: PropTypes.bool,
  sourceCode: PropTypes.string,
  useSourceCode: PropTypes.bool,
  version: PropTypes.number.isRequired,
});

export const CONDITIONS__SHAPE_ARRAY = PropTypes.arrayOf(CONDITIONS__SHAPE_ITEM);
